import { InlineAlert } from '@travelnest/hui';
import * as React from 'react';
import { useStore } from 'react-redux';

import { currentUserId } from '../../../entities/auth/session/selectors';
import { IThunkDispatch } from '../../../store/middleware';
import { IState } from '../../../store/reducer';

export const InlineChurnAlert: React.FC = () => {

	const { getState }: { getState: () => IState, dispatch: IThunkDispatch } = useStore();
	const customerId = currentUserId(getState());
	const churnState = getState().data.customers.byId[customerId]?.churn?.status ?? 'active';

	if (churnState === 'retention_opportunity') return <InlineAlert
		variant="negative"
		heading="Account deactivation"
		content={'Your property calendars have been blocked out following your decision to leave Travelnest. Full account deactivation will take up to 30 days. For any questions, contact customer support at +44 (0)333 666 6111.'}
	/>;

	return null;
};
